import React, { useState } from "react";
import ListModal from "../../components/ListModal";
import { useDispatch, useSelector } from "react-redux";
import { renameList } from "../../../../store/actions/Store/list";
import { showToast } from "../../../../utils/showToast";
import { handleListRequest } from "../../../../store/services/Store/List";
const RenameList = ({ li, props, handleSettingsToggle }) => {
  const { user } = useSelector((state) => state.userReducer);
  const modalData = {
    title: "Rename your list",
    description: "Give your list a new name",
    label: "List Name",
    redButton: "CANCEL",
    purpleButton: "RENAME",
  };
  const [listName, setListName] = useState(li.list);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const renameHandler = async (e) => {
    e.preventDefault();
    if (listName) {
      const result = await handleListRequest({
        method: "put",
        url: `users/${user.data.id}/lists/${li.list_id}`,
        token: user.accessToken,
        data: {
          list_name: listName,
        },
      });
      if (result.success) {
        setListName("");
        dispatch(renameList({ list_id: li.list_id, newName: listName }));
        showToast(result.data, "success", true);
        props.handleClose();
        handleSettingsToggle(li.list_id);
      } else {
        setError(result.message, "error", false);
      }
    }
  };
  const onchangeHandler = (e) => {
    setListName(e.target.value);
    setError("");
  };
  return (
    <ListModal
      isOpen={props.isOpen}
      handleClose={props.handleClose}
      modalData={modalData}
      listName={listName}
      error={error}
      onChangeHandler={onchangeHandler}
      handleAdd={renameHandler}
      closeHandler={props.handleClose}
    />
  );
};

export default RenameList;
